import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { UseI18n } from '../../../../../common/hooks/useI18n'
import { Input } from '../../../../../common/html/input'
import { ScrollComponent } from '../../../../../common/scrollComponent'
import Tree from '../../../../../common/tree'
import { keyBy } from '../../../../../helpers/common'
import classes from '../../../../index.module.scss'
import { selectProvince, setProvince } from '../../../store/slice'

const ProvinceTree = ({ cities, customContainerStyle }) => {
  const dispatch = useDispatch()

  const checked = useSelector(selectProvince)
  const [cityTree, setCityTree] = useState({})

  const [valueSearch, setValueSearch] = useState('')

  useEffect(() => {
    if (cities.length) {
      setCityTree(
        keyBy(
          cities.map((item) => ({ ...item, children: {} })),
          'id',
        ),
      )
    }
  }, [cities])

  const changeSearch = (e) => setValueSearch(e.target.value)

  const setChecked = (items) => dispatch(setProvince(items))

  const textSearch = UseI18n('settingPreferences.SEARCH_PROVINCE')

  return (
    <>
      <Input
        placeHolder={textSearch}
        containerStyle={{ height: '28px' }}
        value={valueSearch}
        onChange={changeSearch}
        noControl
      />
      <div className={classes.treeContainer} style={customContainerStyle}>
        <ScrollComponent>
          <Tree
            treeData={cityTree}
            idKey="id"
            nameKey="name"
            isHaveCheckbox={true}
            valueSearch={valueSearch}
            listChecked={checked}
            setListChecked={setChecked}
            disabledCheckDbClick={true}
            sortKey="name"
          />
        </ScrollComponent>
      </div>
    </>
  )
}

ProvinceTree.propTypes = {
  cities: PropTypes.array.isRequired,
}

export default ProvinceTree
